import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { payrollByPeriodTourSteps } from "./payrollByPeriodTourSteps";

type PayrollByPeriodTourProps = {
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
    action?: string;
  }) => void;
};

export function PayrollByPeriodTour({ run, onCallback }: PayrollByPeriodTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({ status: data.status, type: data.type, index: data.index, action: data.action });
  };

  return (
    <Joyride
      steps={payrollByPeriodTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

export { usePayrollByPeriodTour } from "./usePayrollByPeriodTour";
